import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

const fetchCompaniesVerificationInput = input => ({
  pageNo: 1,
  perPage: Number(process.env.REACT_APP_ADMIN_DEFAULT_PAGE_SIZE) || 50,
  ...input,
});

export const fetchCompaniesVerificationDetails = {
  request: payload =>
    defineAction(
      types.FETCH_COMPANIES_VERIFICATION_DETAILS.REQUEST,
      fetchCompaniesVerificationInput(payload)
    ),
  start: payload =>
    defineAction(
      types.FETCH_COMPANIES_VERIFICATION_DETAILS.START,
      fetchCompaniesVerificationInput(payload)
    ),
  success: ({ input, result }) =>
    defineAction(types.FETCH_COMPANIES_VERIFICATION_DETAILS.SUCCESS, {
      input: fetchCompaniesVerificationInput(input),
      result,
    }),
  failure: ({ input, error }) =>
    defineAction(types.FETCH_COMPANIES_VERIFICATION_DETAILS.FAILURE, {
      input: fetchCompaniesVerificationInput(input),
      error,
    }),
};



// WEBPACK FOOTER //
// ./src/store/features/companies-verification-listings/actions.js